import * as React from 'react'
import { Formik, Form, Field, FieldProps } from 'formik'
import * as Yup from 'yup'
import Select from 'react-select'
import { IGoinZoneObject, GoinZoneType } from 'src/types'
import ErrorBar from 'src/components/ui/ErrorBar'

interface IServiceZonesProps {
  onCancel: () => void
  color: string
  onAddServiceZone: (values: any) => Promise<any>
  specificErrorMsg: string
  buffer: any[]
  showPallete: boolean
  showSpecificError: (msg: string) => void
  onClickColorPick: () => void
  getColorPallete: () => any
  toEdit: IGoinZoneObject | null
  showMessage: (message: string, isError: boolean) => void
  selectedZoneForHotspot: IGoinZoneObject | null
}

interface IServiceZonesState {
  loading: boolean
  statusMessage: string
}

class ServiceZones extends React.Component<IServiceZonesProps, IServiceZonesState> {
  constructor(props: any) {
    super(props)
    this.state = {
      loading: false,
      statusMessage: ''
    }
  }

  public render() {
    return <div>{this.getAddServiceZonePane()}</div>
  }

  private getAddServiceZonePane = () => {
    const addServiceZoneSchema = Yup.object().shape({
      zoneTitle: Yup.string()
        .min(2, 'Must be longer than 2 characters')
        .required('Title is required'),
      description: Yup.string()
        .min(2, 'Must be longer than 2 characters')
        .required('Description is required')
    })

    const zoneOptions = Object.keys(GoinZoneType)
      .filter(t => GoinZoneType[t] !== GoinZoneType.DESIGNATED_HOTSPOT)
      .map(k => {
        return {
          label: GoinZoneType[k],
          value: GoinZoneType[k]
        }
      })

    const onSubmit = (values: any) => {
      this.props.showSpecificError(this.props.buffer.length === 0 ? 'You must select an area' : '')
      if (this.props.buffer.length === 0) {
        return
      }
      this.setState({
        loading: true,
        statusMessage: this.props.toEdit ? 'Saving...' : 'Adding...'
      })

      this.props
        .onAddServiceZone({
          ...values,
          mapObjectType: 'service',
          original: this.props.toEdit
        })
        .then(
          () => {
            // below code is unnecessary it throws an error because it tries to update state of unmounted component
            // this.setState({
            //   loading: false,
            //   statusMessage: ''
            // })
            console.log('designated zone added')
          },
          err => {
            this.props.showSpecificError('Failed to add service zone: ' + err)
            this.setState({
              loading: false,
              statusMessage: ''
            })
          }
        )
    }

    const textInput = ({ field, form }: FieldProps<any>) => (
      <input className='rounded p1 h4 mt02 border-light-grey4' type='text' {...field} />
    )

    const textAreaInput = ({ field, form }: FieldProps<any>) => (
      <textarea
        className='rounded p1 h4 mt02 border-light-grey4'
        cols={50}
        rows={4}
        style={{ resize: 'none' }}
        {...field}
      />
    )

    const selectInput = ({ field, form }: FieldProps<any>) => {
      return (
        <select {...field} className='rounded p1 h4 mt02 border-light-grey4 w100'>
          {zoneOptions.map(option => {
            return (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            )
          })}
        </select>
      )
    }

    const bodyStyle: any = {
      pointerEvents: this.state.loading ? 'none' : 'auto',
      opacity: this.state.loading ? 0.4 : 1.0
    }

    const render = ({ errors, touched }: any) => (
      <Form>
        <div style={bodyStyle}>
          <div className='mt1'>
            <div className='flex'>
              <div style={{ flex: 1 }}>
                <label className='h5 font-dark-grey' htmlFor='zoneTitle'>
                  Title
                </label>
                <Field name='zoneTitle' render={textInput} />
              </div>
              <div className='ml1 mt03'>
                <label className='h5 font-dark-grey block'>Color</label>
                <div
                  onClick={this.props.onClickColorPick}
                  className='rounded'
                  style={{
                    WebkitBoxShadow: 'inset 0px 0px 0px 1px #858585',
                    MozBoxShadow: 'inset 0px 0px 0px 1px #858585',
                    boxShadow: 'inset 0px 0px 0px 1px #858585',
                    cursor: 'pointer',
                    display: 'inline-block',
                    width: '38px',
                    height: '38px',
                    backgroundColor: this.props.color
                  }}
                >
                  &nbsp;
                </div>
              </div>
            </div>
            {touched.zoneTitle && errors.zoneTitle && (
              <div className='font-small weight-300 font-red'>{errors.zoneTitle}</div>
            )}
          </div>
          {this.props.showPallete && this.props.getColorPallete()}

          <div className='mt1'>
            <label className='h5 font-dark-grey' htmlFor='description'>
              Description
            </label>
            <Field name='description' render={textAreaInput} />
            {touched.description && errors.description && (
              <div className='font-small weight-300 font-red'>{errors.description}</div>
            )}
          </div>

          {!this.props.selectedZoneForHotspot && (
            <div className='mt1'>
              <label className='h5 font-dark-grey' htmlFor='zoneType'>
                Zone Type
              </label>
              <Field name='zoneType' render={selectInput} />
            </div>
          )}

          {this.props.specificErrorMsg.length > 0 && (
            <div className='font-small weight-300 font-red mt2'>{this.props.specificErrorMsg}</div>
          )}

          <div className='flex mt2'>
            <div style={{ flex: 1 }}>&nbsp;</div>
            <div onClick={this.props.onCancel} className='CancelButton btn bg-white rounded font-light-grey mr2'>
              Cancel
            </div>
            <button className='SubmitServiceZones btn bg-green rounded font-white weight-300' type='submit'>
              {this.props.toEdit ? 'Save' : 'Add'}
            </button>
          </div>
        </div>
        <div className='flex'>
          <div style={{ flex: 1 }}>&nbsp;</div>
          {this.state.statusMessage.length > 0 && (
            <div className='font-small weight-300 font-green mt2'>{this.state.statusMessage}</div>
          )}
        </div>
      </Form>
    )
    const defaultZoneType = () => {
      if (this.props.selectedZoneForHotspot) {
        return GoinZoneType.DESIGNATED_HOTSPOT
      }
      if (this.props.toEdit) {
        return this.props.toEdit.zoneType
      }
      return GoinZoneType.SERVICE_ZONE
    }
    return (
      <div className='mb3'>
        <div style={{ width: '100%' }} className='flex'>
          {!this.props.selectedZoneForHotspot ? (
            <div className='h5 weight-600'>Add Service Zones</div>
          ) : (
            <span>Zone: {this.props.selectedZoneForHotspot.name}</span>
          )}
        </div>
        <Formik
          initialValues={{
            zoneTitle: this.props.toEdit ? this.props.toEdit.name : '',
            description: this.props.toEdit ? this.props.toEdit.description : '',
            price: this.props.toEdit ? this.props.toEdit.price : 0,
            zoneType: defaultZoneType()
          }}
          validationSchema={addServiceZoneSchema}
          onSubmit={onSubmit}
          render={render}
        />
      </div>
    )
  }
}

export default ServiceZones



// WEBPACK FOOTER //
// ./src/components/services/edit/goinzones/ServiceZones.tsx